import i18n from "@/i18n"
import { applyLandingBrand } from "@/lib/siteHosts"

export function landingCopy(language, key) {
  const translate = i18n.getFixedT(language, "roofingLight")
  return applyLandingBrand(translate(key, { returnObjects: true }))
}
